document.addEventListener("turbolinks:load", function() {
  var emailButtons = document.querySelectorAll(".test-email")
  var addNew = document.querySelector(".add-new-email")

  if (addNew) { addNew.addEventListener("click", updateLisenter); }

  for(var i = 0; i < emailButtons.length; i++){
    emailButtons[i].addEventListener("click", testEmail);
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function updateLisenter() {
    await sleep(1000);
    var emailButtons = document.querySelectorAll(".test-email")
    emailButtons[emailButtons.length - 1].addEventListener("click", testEmail);
  }

  function testEmail(event) {
    event.preventDefault()
    const email = this.parentNode.parentNode.getElementsByTagName('input')[0].value
    console.log(email)

    $.ajax({
      url: `/test_mailer`,
      type: "post",
      data: {"email": email},
      success: function(data){
        alert('Test email has been sent.')
      },
      error: function(data){
        alert('Error occurred. Test did not go through.')
      }
    });
  }
});
